// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__z9xNX","title":"card_title__2s9Bh","inActive":"card_inActive__3AaXZ"};